import type { ComponentType } from 'react'
import {
  AgendaIcon,
  ClientsIcon,
  ContractsIcon,
  DashboardIcon,
  InvoicesIcon,
  PaymentsIcon,
  QuotesIcon,
  SettingsIcon,
  TasksIcon,
  TechniciansIcon,
} from '@/components/icons/sidebar'
import type { PermissionModule } from '@/types'
import { canViewModule } from '@/lib/permissions'

export interface NavItem {
  label: string
  to: string
  icon: ComponentType<{ className?: string }>
  /** Portal module required to see this item (needs `{module}.view`). */
  module?: PermissionModule
  // Child route prefixes that belong to this section: the item stays highlighted
  // when the URL is under one of them.
  childPaths?: string[]
}

// GENERAL nav group (matches dashboard.md sidebar composition).
export const generalNav: NavItem[] = [
  {
    label: 'Dashboard',
    to: '/dashboard',
    icon: DashboardIcon,
    module: 'dashboard',
  },
  {
    label: 'Calendar',
    to: '/calendar',
    icon: AgendaIcon,
    module: 'agenda',
    // Jobs are reached through the Agenda; keep it highlighted on /jobs/*.
    childPaths: ['/jobs'],
  },
  { label: 'Clients',
    to: '/clients',
    icon: ClientsIcon,
    module: 'clients'
  },
  { label: 'Quotes',
    to: '/quotes',
    icon: QuotesIcon,
    module: 'quotes'
  },
  {
    label: 'Invoices',
    to: '/invoices',
    icon: InvoicesIcon,
    module: 'invoices',
    childPaths: ['/credit-notes'],
  },
  {
    label: 'Payments',
    to: '/payments',
    icon: PaymentsIcon,
    module: 'payments',
  },
  {
    label: 'Contracts',
    to: '/contracts',
    icon: ContractsIcon,
    module: 'contracts',
  },
  {
    label: 'Technicians',
    to: '/technicians',
    icon: TechniciansIcon,
    module: 'technicians',
  },
  { 
    label: 'Tasks',
    to: '/tasks',
    icon: TasksIcon,
    module: 'tasks'
  },
  {
    label: 'Settings',
    to: '/settings',
    icon: SettingsIcon,
    module: 'settings',
  },
]

/** Filter nav by effective module permissions (2.11.3). */
export function visibleNav(
  items: NavItem[],
  permissions: string[] | undefined
) {
  return items.filter(i => !i.module || canViewModule(permissions, i.module))
}
